import Barba from 'barba.js'
import TweenLite from 'gsap/TweenLite'

export default Barba.BaseView.extend({
    namespace: 'accordion',
    cards: null,
    callback: null,
    onEnter() {
        this.callback = this.toggleContent.bind(this);
    },
    onEnterCompleted() {
        this.enableAccordion()
    },
    onLeave() {
        this.disableAccordion()
    },
    onLeaveCompleted() {
    },
    enableAccordion() {
        if( document.querySelector('.accordion') ) {
            this.accordions = document.querySelectorAll('.accordion');
            this.accordions.forEach( el => el.querySelector('.accordion-header').addEventListener('click', this.callback) );
            return true
        }
        return false
    },
    disableAccordion() {
        if( this.accordions ) {
            this.accordions.forEach( el => el.querySelector('.accordion-header').removeEventListener('click', this.callback) )
            return true
        }
        return false
    },
    toggleContent(ev) {
        ev.preventDefault();
        let accordion = ev.currentTarget.closest('.accordion');
        console.log( accordion, accordion.querySelector('.accordion-body') );
        let content = accordion.querySelector('.accordion-body');
        if( accordion.classList.contains('active') ) {
            TweenLite.to( content, .3, { height: 0,
                onComplete: () => {
                    accordion.classList.remove('active')
                } }
            )
        } else {
            TweenLite.to( content, .3, { height: content.scrollHeight,
                onComplete: () => {
                    accordion.classList.add('active')
                } }
            )
        }
    }
})